/* eslint-disable */
export default {
  inventoryItemType: {
    refresh: 'Refresh'
  }
};